import { getCampaignsIntegrationDataHook } from "./integrationDataHooks";
import { getCampaignsItemsDataHook } from "./itemsDataHooks";
import { getCampaignsRowClickHook } from "./rowClickHooks";

import { registerSchemaHooks } from "@/features/integrations/shared/renderer/hooks/schemaRegistry";

registerSchemaHooks("campaigns", {
  getItemsDataHook: getCampaignsItemsDataHook,
  getIntegrationDataHook: getCampaignsIntegrationDataHook,
  getRowClickHook: getCampaignsRowClickHook,
});
